var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitialDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 12.7H11.4M5.1 15.4H8.25M15 1H2.4C2.16131 1 1.93239 1.09482 1.7636 1.2636C1.59482 1.43239 1.5 1.66131 1.5 1.9V18.1C1.5 18.3387 1.59482 18.5676 1.7636 18.7364C1.93239 18.9052 2.16131 19 2.4 19H15C15.2387 19 15.4676 18.9052 15.6364 18.7364C15.8052 18.5676 15.9 18.3387 15.9 18.1V1.9C15.9 1.66131 15.8052 1.43239 15.6364 1.2636C15.4676 1.09482 15.2387 1 15 1Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09998 4.6001H11.4V9.1001H5.09998V4.6001Z",
    stroke: "#00C6C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialDataIcon);
export default __webpack_public_path__ + "static/media/initial-data-icon.0e296934b70d06d120d3f0b0a16280b5.svg";
export { ForwardRef as ReactComponent };